/**
 * Horizontal product card: update image on swatch change and open quick-buy modal with the variant that matches the selected color swatch.
 */
(() => {
  if (
    document.documentElement.hasAttribute(
      "data-wr-product-card-horizontal-swatch-inited"
    )
  ) {
    return;
  }
  document.documentElement.setAttribute(
    "data-wr-product-card-horizontal-swatch-inited",
    "1"
  );

  document.addEventListener("change", (e) => {
    const input = e.target;
    if (
      input.type !== "radio" ||
      !input.name ||
      !input.name.startsWith("swatch-")
    ) {
      return;
    }

    const wrapper = input.closest(
      ".wr-product-card-horizontal__swatch-wrapper"
    );
    const card = input.closest(".wr-product-card-horizontal");
    if (!wrapper || !card) {
      return;
    }

    const imageSrc = wrapper.dataset.variantImage;
    const imageSrcset = wrapper.dataset.variantImageSrcset;
    if (!imageSrc) {
      return;
    }

    const img = card.querySelector(
      ".wr-product-card-horizontal__media-link img"
    );
    if (!img) {
      return;
    }

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    const duration = reduceMotion ? 0 : 300;

    if (img.dataset.swatchTransitionTimer) {
      clearTimeout(Number(img.dataset.swatchTransitionTimer));
      delete img.dataset.swatchTransitionTimer;
    }

    if (duration === 0) {
      img.src = imageSrc;
      img.srcset = imageSrcset || "";
      return;
    }

    img.style.opacity = "0";

    setTimeout(() => {
      img.src = imageSrc;
      img.srcset = imageSrcset || "";
    }, duration - 100);

    img.dataset.swatchTransitionTimer = String(
      setTimeout(() => {
        delete img.dataset.swatchTransitionTimer;
        img.style.opacity = "1";
      }, duration)
    );
  });

  document.addEventListener(
    "click",
    (e) => {
      const card = e.target.closest(".wr-product-card-horizontal");
      if (!card?.dataset.productHandle) {
        return;
      }

      const button = e.target.closest("button[aria-controls]");
      if (!button || !card.contains(button)) {
        return;
      }

      const modal = document.getElementById(
        button.getAttribute("aria-controls")
      );
      if (!modal || modal.tagName !== "QUICK-BUY-MODAL") {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      const checkedInput = card.querySelector('input[name^="swatch-"]:checked');
      const wrapper = checkedInput?.closest(
        ".wr-product-card-horizontal__swatch-wrapper"
      );
      const variantId =
        wrapper?.dataset.variantId || card.dataset.defaultVariantId;

      modal.setAttribute(
        "handle",
        card.dataset.productHandle + (variantId ? "?variant=" + variantId : "")
      );
      modal.show();
    },
    true
  );
})();
